import { Stack, Typography } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { LegislationLibraryUrlField } from "./legislation-library-url-field"
import { LegislationLibraryFoldersField } from "./legislation-library-folders-field"

const LABEL_SX = { color: "text.secondary", fontWeight: 600, letterSpacing: 0.5 }

export function LegislationDetailForm({ id }) {
    return (
        <Stack spacing={3} data-cy="legislation-detail-form">
            <Stack spacing={0.5}>
                <Typography variant="overline" sx={LABEL_SX}>
                    NAME
                </Typography>
                <BoundTextField field="title" label="" sideEffects data-cy="legislation-detail-name-input" />
            </Stack>

            <Stack spacing={0.5}>
                <Typography variant="overline" sx={LABEL_SX}>
                    DESTINATION URL
                </Typography>
                <LegislationLibraryUrlField label="" sideEffects data-cy="legislation-detail-url-input" />
            </Stack>

            <Stack spacing={0.5}>
                <Typography variant="overline" sx={LABEL_SX}>
                    DESCRIPTION
                </Typography>
                <BoundTextField
                    field="description"
                    label=""
                    multiline
                    rows={4}
                    sideEffects
                    data-cy="legislation-detail-description-input"
                />
            </Stack>

            <LegislationLibraryFoldersField id={id} />
        </Stack>
    )
}
